import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

/**
 * CardWW4 (Softkeys) API
 * Оплата международными банковскими картами VISA/MC в долларах через провайдера Softkeys.
 * Используется для трёх визуальных методов: Visa/MasterCard, Google Pay, Apple Pay.
 * Структура эндпоинтов идентична cardww1/cardww2/cardww3, отличается только путь /api/cardww4/
 * и поле `cardww4` в пакетах /api/topup/.
 */

/**
 * Получить конфигурацию cardww4 (курсы и лимиты)
 */
export const fetchCardWw4Config = async () => {
  try {
    const response = await apiService.makeRequest('/api/cardww4/')

    if (response.cardww4) {
      return { ...response.cardww4, promo: response.promo || null }
    }

    throw new Error('Invalid response format: cardww4 config not found')
  } catch (error) {
    console.error('Error fetching CardWW4 config:', error)
    throw error
  }
}

/**
 * Получить пакеты для cardww4 из общего списка тарифов /api/topup/
 * Фильтрует только те пакеты, у которых есть поле cardww4
 */
export const fetchCardWw4Packages = async () => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    if (response.topup && Array.isArray(response.topup)) {
      return response.topup.filter((pkg) => pkg.cardww4 !== undefined)
    }

    throw new Error('Invalid response format: topup array not found')
  } catch (error) {
    console.error('Error fetching CardWW4 packages:', error)
    throw error
  }
}

// Нормализация ошибок бэкенда cardww4 к единому виду
const normalizeCardWw4CreateError = (response) => {
  if (!response?.error) return null

  if (response.error === 'error sum') return 'INVALID_AMOUNT'
  if (response.error === 'error backend') return 'BACKEND_ERROR'
  if (response.error === 'error limit') return 'PAYMENT_LIMIT'

  return response.error
}

/**
 * Создать платеж cardww4 по сумме в долларах
 */
export const createPaymentByDollars = async (dollars) => {
  try {
    const response = await apiService.makeRequest('/api/cardww4/', {
      method: 'POST',
      body: JSON.stringify({ dollar: dollars })
    })

    const normalizedError = normalizeCardWw4CreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating CardWW4 payment by dollars:', error)
    throw error
  }
}

/**
 * Создать платеж cardww4 по количеству кристаллов
 */
export const createPaymentByCrystals = async (crystals) => {
  try {
    const response = await apiService.makeRequest('/api/cardww4/', {
      method: 'POST',
      body: JSON.stringify({ crystal: crystals })
    })

    const normalizedError = normalizeCardWw4CreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating CardWW4 payment by crystals:', error)
    throw error
  }
}

/**
 * Открыть ссылку на оплату cardww4 через Telegram WebApp API
 */
export const openCardWw4Payment = (paymentLink, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(paymentLink, onRedirect, 'CardWW4', paymentWindow)
}

export default {
  fetchCardWw4Config,
  fetchCardWw4Packages,
  createPaymentByDollars,
  createPaymentByCrystals,
  openCardWw4Payment
}
